
import React from 'react';
import { Client } from '../types';
import { EnrichmentResponse } from '@/hooks/useCompanyEnrichment';
import { EnrichmentDialogDataType } from '@/hooks/enrichment/useEnrichmentDialogManager';
import { ClientDetailsHeader } from './ClientDetailsHeader';
import { ClientUpdateForm } from '../ClientUpdateForm';
import { ClientDisplayView } from './ClientDisplayView';
import { ClientEnrichmentResultsDialog } from '../ClientEnrichmentResultsDialog';
// import { BackendProgressStage } from '../enrichment-dialog/enrichmentTypes'; // Not used directly here

interface ClientDetailsContentProps {
  client: Client;
  showEditForm: boolean;
  onEdit: () => void;
  onDeleteClient: () => void;
  onCloseEditForm: () => void;
  onSuccessEditForm: () => void;
  refetchClient: () => void;
  fieldsWithNewDataSet: Set<keyof Client>; // Changed from Record<string, boolean> to Set<keyof Client>
  handleEnrichClient: () => void;
  isEnrichmentTriggering: boolean;
  isEnrichmentDialogOpen: boolean;
  enrichmentDialogData: EnrichmentDialogDataType | null;
  handleEnrichmentDialogClose: () => void;
  handleEnrichmentApplied: () => void;
  isEnrichmentPolling?: boolean;
  lastEnrichmentData: Partial<EnrichmentResponse> | null;
  handleCancelEnrichment: (runId: string, clientId: string) => Promise<void>;
  isCancellingEnrichment: boolean;
}

export const ClientDetailsContent: React.FC<ClientDetailsContentProps> = ({
  client,
  showEditForm,
  onEdit,
  onDeleteClient,
  onCloseEditForm,
  onSuccessEditForm,
  refetchClient,
  fieldsWithNewDataSet, // Use the Set prop
  handleEnrichClient,
  isEnrichmentTriggering,
  isEnrichmentDialogOpen,
  enrichmentDialogData,
  handleEnrichmentDialogClose,
  handleEnrichmentApplied,
  isEnrichmentPolling,
  lastEnrichmentData,
  handleCancelEnrichment,
  isCancellingEnrichment,
}) => {
  const currentProgressStage = lastEnrichmentData?.progress_stage || 
                               (client.enrichment_status === 'pending' || client.enrichment_status === 'processing' ? client.enrichment_status : undefined) ||
                               undefined;

  return (
    <div className="container mx-auto p-4 md:p-6 space-y-6">
      <ClientDetailsHeader
        client={client}
        onEdit={onEdit}
        onDelete={onDeleteClient}
        onEnrich={handleEnrichClient}
        isEnriching={isEnrichmentTriggering}
        isPolling={isEnrichmentPolling}
        lastEnrichmentData={lastEnrichmentData}
        lastEnrichmentProgressStage={currentProgressStage}
      />

      {showEditForm ? (
        <ClientUpdateForm
          client={client}
          onCancel={onCloseEditForm}
          onSuccess={onSuccessEditForm}
        />
      ) : (
        <ClientDisplayView
          client={client}
          fieldsWithNewDataSet={fieldsWithNewDataSet} // Pass the Set
          lastEnrichmentData={lastEnrichmentData}
          handleEnrichClient={handleEnrichClient}
          isEnrichmentTriggering={isEnrichmentTriggering}
          isEnrichmentPolling={isEnrichmentPolling}
          refetchClient={refetchClient}
        />
      )}

      {isEnrichmentDialogOpen && enrichmentDialogData && (
        <ClientEnrichmentResultsDialog
          client={enrichmentDialogData.client}
          enrichmentResult={enrichmentDialogData.result as EnrichmentResponse | null}
          isOpen={isEnrichmentDialogOpen}
          onClose={handleEnrichmentDialogClose}
          onApplied={handleEnrichmentApplied}
          onCancelEnrichment={handleCancelEnrichment}
          isCancellingEnrichment={isCancellingEnrichment}
        />
      )}
    </div>
  );
};
